import { render, staticRenderFns } from "./TeamRow.vue?vue&type=template&id=5f50ee10&scoped=true&"
import script from "./TeamRow.vue?vue&type=script&lang=js&"
export * from "./TeamRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f50ee10",
  null
  
)

export default component.exports